import { RootState } from '@/store';

export const selectProductAdminRoles = (state: RootState) =>
  state.productAdminRole.roles;
export const selectProductAdminRolesLoading = (state: RootState) =>
  state.productAdminRole.loading;
export const selectProductAdminRolesError = (state: RootState) =>
  state.productAdminRole.error;
